import { HTMLAttributes, ReactNode } from 'react';

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'info' | 'success' | 'warning' | 'error';
  title?: string;
  icon?: ReactNode;
  onClose?: () => void;
}

export function Alert({
  variant = 'info',
  title,
  icon,
  onClose,
  className = '',
  children,
  ...props
}: AlertProps) {
  const variantStyles = {
    info: 'bg-primary-soft border-primary text-primary',
    success: 'bg-success-soft border-success text-success',
    warning: 'bg-warning-soft border-warning text-warning',
    error: 'bg-error-soft border-error text-error',
  };

  const iconColors = {
    info: 'text-primary',
    success: 'text-success',
    warning: 'text-warning',
    error: 'text-error',
  };

  return (
    <div
      className={`rounded-lg border p-4 ${variantStyles[variant]} ${className}`}
      role="alert"
      {...props}
    >
      <div className="flex">
        {icon && <div className={`flex-shrink-0 ${iconColors[variant]}`}>{icon}</div>}
        <div className={`${icon ? 'ml-3' : ''} flex-1`}>
          {title && <h3 className="font-medium">{title}</h3>}
          <div className={`${title ? 'mt-2' : ''} text-sm`}>{children}</div>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="flex-shrink-0 ml-3 inline-flex text-current hover:opacity-75"
            aria-label="Close"
          >
            <svg
              className="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
